import { useState } from 'react'

/** A round user picture, or the name's initials when there is none. */
export function Avatar({ src, name, className = '' }: { src?: string; name: string; className?: string }) {
  const [failed, setFailed] = useState(false)
  if (src && !failed) {
    return <img className={`avatar ${className}`} src={src} alt="" loading="lazy" decoding="async" onError={() => setFailed(true)} />
  }
  return (
    <span className={`avatar avatar--initials ${className}`} aria-hidden="true">
      {name.trim().slice(0, 2) || '?'}
    </span>
  )
}
